import React from "react";
import PropTypes from "prop-types";
import EventEmitter from "eventemitter3";
import { BRANDS, TYPES, MODES } from "CONFIGS";
import { AppContext } from "./context";
import { InputSearchProvider } from "./context/app/searchValuesContext";
import { BookingSearchBox } from "./views/BookingSearchBox";

const App = ({
	lang,
	brand,
	type,
	mode,
	tabs,
	alias,
	codeAg,
	reactDOM,
	appRoot,
	emitter,
	profile,
	newMobileDesign,
}) => (
	<AppContext.Provider
		config={{
			lang: lang === "fr" ? "fr" : "en",
			reactDOM,
			appRoot,
			brand,
			type,
			mode,
			alias,
			codeAg,
			emitter,
			profile,
			newMobileDesign,
		}}>
		<InputSearchProvider>
			<BookingSearchBox brand={brand} type={type} standalone={mode === MODES.TABS} tabs={tabs} mode={mode} />
		</InputSearchProvider>
	</AppContext.Provider>
);

App.propTypes = {
	lang: PropTypes.oneOf(["en", "fr"]),
	reactDOM: PropTypes.instanceOf(DocumentFragment),
	appRoot: PropTypes.any.isRequired,
	brand: PropTypes.oneOf(Object.keys(BRANDS)),
	type: PropTypes.string,
	mode: PropTypes.string,
	tabs: PropTypes.arrayOf(PropTypes.string),
	alias: PropTypes.string,
	codeAg: PropTypes.string,
	emitter: PropTypes.instanceOf(EventEmitter).isRequired,
	profile: PropTypes.string,
	newMobileDesign: PropTypes.bool,
};

App.defaultProps = {
	lang: "en",
	reactDOM: document,
	brand: BRANDS.SWG,
	type: TYPES.PACKAGES,
	mode: MODES.SEARCH,
	tabs: [TYPES.PACKAGES, TYPES.FLIGHTS, TYPES.HOTELS, TYPES.CRUISES],
	alias: "btd",
	codeAg: "rds",
	profile: undefined,
	newMobileDesign: false,
};

export default App;
